import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import './LocationLandingPage.css';

const LocationLandingPage = ({
  title,
  description,
  path,
  h1,
  intro,
  serviceType,
  highlights,
  faqs,
  pricingTitle,
  pricingIntro,
  pricingItems = [],
  pricingCta,
}) => {
  const canonicalUrl = `https://techieinteriors.co.ke${path}`;
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType,
    areaServed: [
      { '@type': 'City', name: 'Nairobi' },
      { '@type': 'Country', name: 'Kenya' },
    ],
    provider: {
      '@type': 'LocalBusiness',
      name: 'Techie Interiors',
      url: 'https://techieinteriors.co.ke',
      telephone: '+254748600208',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Nairobi',
        addressCountry: 'KE',
      },
    },
    description,
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer },
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://techieinteriors.co.ke/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: h1,
        item: canonicalUrl,
      },
    ],
  };

  return (
    <div className="container location-page">
      <SEO
        title={title}
        description={description}
        url={canonicalUrl}
        structuredData={[serviceSchema, faqSchema, breadcrumbSchema]}
        addBreadcrumb={false}
      />

      <section className="location-section location-hero">
        <h1 className="location-title">{h1}</h1>
        <p className="location-intro">{intro}</p>
      </section>

      <section className="location-section location-card">
        <h2 className="location-heading">What We Deliver</h2>
        <ul className="location-list">
          {highlights.map((item, idx) => (
            <li key={`${idx}-${typeof item === 'string' ? item : 'highlight'}`}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="location-section location-card">
        <h2 className="location-heading">Frequently Asked Questions</h2>
        {faqs.map((faq) => (
          <article className="location-faq-item" key={faq.question}>
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </article>
        ))}
      </section>

      {pricingItems.length > 0 && (
        <section className="location-section location-card">
          <h2 className="location-heading">{pricingTitle || 'Pricing'}</h2>
          {pricingIntro && <p className="location-pricing-intro">{pricingIntro}</p>}
          <div className="location-pricing-grid">
            {pricingItems.map((item) => (
              <article className="location-pricing-item" key={item.name}>
                <h3>{item.name}</h3>
                <p>{item.price}</p>
              </article>
            ))}
          </div>
          {pricingCta && <p className="location-pricing-cta">{pricingCta}</p>}
        </section>
      )}

      <section className="location-section location-card">
        <h2 className="location-heading">Related Interior Services</h2>
        <p className="location-related-text">
          Explore <Link to="/services">all interior services</Link>, view our{' '}
          <Link to="/project">recent projects</Link>, or request a{' '}
          <Link to="/contact-us">free consultation in Nairobi</Link>. For service-specific pages, see{' '}
          <Link to="/gypsum-ceiling">gypsum ceilings</Link>,{' '}
          <Link to="/kitchen-wardrobe-fitting">kitchen and wardrobe fitting</Link>, and{' '}
          <Link to="/tv-gypsum-wall">TV and gypsum wall units</Link>.
        </p>
      </section>
    </div>
  );
};

export default LocationLandingPage;
